import { useIntl } from "react-intl";
import React from "react";
import ImunoContainer from "./imuno.container";

function ImunoContainerIntl() {
    const intl = useIntl()
    return (
        <ImunoContainer intl={intl}></ImunoContainer>
    );
  }

  export default ImunoContainerIntl


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/imuno/imuno.intl.js